import styled, { createGlobalStyle } from 'styled-components'
import { COLORS } from '@enums/colors'
import { device } from '@util/breakpoints'
import { spacing } from '@util/spacing'

export const BodyNoScroll = createGlobalStyle`
    body {
        position:fixed;
        overflow: hidden;
    }
`

type BackbroundOverlayProps = {
    backgroundColor?: string
}

export const BackgroundOverlay = styled.div<BackbroundOverlayProps>`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: ${props => props.backgroundColor ? props.backgroundColor : COLORS.backgroundOverlay};
    z-index: 9999;
`

export const ModalContainer = styled.div`
    position: fixed;
    background-color: ${COLORS.white};
    border-radius: 0.5rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 26.5rem;
    height: auto;
`

export const AssessmentsModalContainer = styled(ModalContainer)`
    background-color: ${COLORS.transparent};
    width: 100%;
    height: 100%;

    @media ${device.mobileL} {
        max-width: 36rem;
        max-height: 43rem;
    } 
`

export const OverlayHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${spacing.s24};

    svg path {
        fill: ${COLORS.white};
    }
`
